exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#mobile_entry {\n  color: #39ff14;\n}\n", ""]);
